import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./responsive.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const svgIcon = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zZ2...`;

if ("Notification" in window) {
  Notification.requestPermission().then((permission) => {
    if (permission !== "granted") {
      console.warn("Notifications are disabled.");
    }
  });
}

function showNotification(title, body) {
  if (Notification.permission === "granted") {
    new Notification(title, { body, icon: svgIcon });
  }
}

window.addEventListener("offline", () => {
  // console.log("You are offline.");
  showNotification("Offline Mode", "You have lost internet connection.");
});

window.addEventListener("online", () => {
  // console.log("You are back online.");
  showNotification(
    "Back Online",
    "Your internet connection has been restored."
  );
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer position="top-center" theme="dark" />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
